module.exports = __webpack_public_path__ + "img/ep2.44d2f355.jpg";